import { useState } from 'react';
import {
    BlockMap,
    BlockEditorSheet,
    VIEW_MEMBERSHIP,
} from '../../../../../../components/blocks';
import AffectedItemsNotice from '../../../AffectedItemsNotice';
import styles from '../../CaseBuilderEnhanced.module.css';

/**
 * Blocks step — Block Map library (case scope).
 */
export default function BlocksStep({
    doc,
    workspace,
    caseId,
    onGoToStep,
    onLoadProtocol,
    loadPending = false,
}) {
    const [sheet, setSheet] = useState({
        open: false,
        mode: 'add',
        block: null,
        region: null,
        initialView: VIEW_MEMBERSHIP,
    });

    const scope = {
        type: 'case',
        caseId,
        doc,
        setDoc: workspace.setDoc,
    };

    const blocks = doc?.blocks ?? [];
    const protocolName = workspace.selectedProtocol?.name;

    const closeSheet = () => setSheet({
        open: false,
        mode: 'add',
        block: null,
        region: null,
        initialView: VIEW_MEMBERSHIP,
    });

    const openAddBlock = () => setSheet({
        open: true,
        mode: 'add',
        block: null,
        region: null,
        initialView: VIEW_MEMBERSHIP,
    });

    const openEditBlock = (block) => setSheet({
        open: true,
        mode: 'edit',
        block,
        region: null,
        initialView: VIEW_MEMBERSHIP,
    });

    return (
        <div className={styles.stepContent}>
            <BlockMap
                blocks={blocks}
                showUsage
                onLoadProtocol={onLoadProtocol}
                loadPending={loadPending}
                onAddBlock={openAddBlock}
                onEditBlock={openEditBlock}
                onUsageClick={onGoToStep ? () => onGoToStep('slides') : undefined}
            />

            {workspace.affectedItemsAfterBlockRemoval?.length > 0 && (
                <AffectedItemsNotice
                    itemIds={workspace.affectedItemsAfterBlockRemoval}
                    onDismiss={() => workspace.setAffectedItemsAfterBlockRemoval(null)}
                />
            )}

            <BlockEditorSheet
                open={sheet.open}
                mode={sheet.mode}
                block={sheet.block}
                region={sheet.region}
                initialView={sheet.initialView}
                scope={scope}
                protocolName={protocolName}
                onClose={closeSheet}
                onAffectedItems={workspace.setAffectedItemsAfterBlockRemoval}
            />
        </div>
    );
}
